import { PaidCancellation } from '@models/invoice/paid-cancellation';
import { InvoiceTransaction } from './invoice-transaction';

export class PaidCancellationInvoiceTransaction {
  financeTransaction: InvoiceTransaction;
  paidCancellation: PaidCancellation = null;
}
